/**
 * Mirrors /form survey submissions into Pipedrive as leads.
 *
 * The request goes through the CMS rather than straight to Pipedrive so the API
 * token is never part of the website bundle. Every answer is sent: the CMS maps
 * what Pipedrive has a field for and puts the rest in a note on the lead, per
 * packages/cms/api/pipedrive-lead/config/fields.js.
 */
export type PipedriveLead = {
  business: string
  firstName: string
  lastName: string
  phone: string
  email: string
  company: string
  website: string
  city: string
  state: string
  country: string
  role: string
  enroll: string
  timeline: string
  referral: string
  referral_client: string
  referred_by: string
  existing_club: string
  membership_type: string
  member_count: string
  amenities: string
  other_amenity: string
  payments: string
  point_of_sale: string
  property_management_system: string
  reservation_system: string
  booking_system: string
  access_control: string
  member_approval: string
}

function cmsUrl(): string {
  const graphqlUrl =
    (import.meta.env.REACT_APP_WEBSITE_API_URL as string) ??
    `https://${window.location.host.includes('stage') ? 'stage.' : ''}cms.peoplevine.com/graphql`

  return `${graphqlUrl.replace(/\/graphql\/?$/, '')}/pipedrive-leads`
}

/**
 * Deliberately never rejects: the Peoplevine survey submission owns the form's
 * success state, and a CRM mirror failing should not cost us the lead.
 */
export async function sendPipedriveLead(lead: PipedriveLead): Promise<void> {
  if (import.meta.env.DEV) {
    console.log('Pipedrive lead:', lead)
    return
  }

  try {
    await fetch(cmsUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lead),
    })
  } catch (reason) {
    console.error('Pipedrive lead failed', reason)
  }
}
